export default __webpack_public_path__ + "static/media/pink_rank.415ca336.png";